import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces/details-paginated-request'
import { getCustomerServiceOrders } from '../../customers'

export function useCustomerServiceOrders(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(
    ['customerServiceOrders', query],
    () => getCustomerServiceOrders(query)
  )
  return { data, error, isLoading }
}
